<template>
<div>
<account></account>
</div>
</template>

<script>
import Account from "@/components/userCenter/account";
export default {
  name: "userCenter",
  components: {Account}
}
</script>

<style scoped>

</style>
